import { Heart, Menu, Phone, Sparkles } from "lucide-react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { trackContactClick } from "../lib/analytics";
import { AGENCY_PHONE, AGENCY_PHONE_DISPLAY } from "../lib/contact";

const navItems = [
  ["Acheter", "/biens?transaction=vente"],
  ["Louer", "/biens?transaction=location"],
  ["Vendre", "/estimation"],
  ["Honoraires", "/honoraires"],
  ["Guides", "/guides"],
  ["Expertise", "/expertise"],
  ["L’agence", "/agence"],
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  return (
    <header className="site-header" data-testid="site-header">
      <Link className="brand" to="/" data-testid="brand-home-link" aria-label="Pimp My Place - Accueil">
        <img
          className="brand-logo"
          src="https://customer-assets-agu9un31.emergentagent.net/job_estate-portal-143/artifacts/e0z5veoe_NEW%20LOGO%20PMP.png"
          alt="Pimp My Place — L'immobilier qui vous ressemble, Sud de la France"
          decoding="async"
        />
      </Link>
      <nav className="desktop-nav" aria-label="Navigation principale">
        {navItems.map(([label, path]) => (
          <NavLink key={label} to={path} data-testid={`navigation-${label.toLowerCase().replace("'", "")}-link`}>
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="header-actions">
        <Link className="icon-button" to="/favoris" data-testid="favorites-link" aria-label="Voir mes biens favoris">
          <Heart size={19} />
        </Link>
        <a className="header-phone" href={`tel:${AGENCY_PHONE}`} onClick={() => trackContactClick("phone", "header")} data-testid="header-phone-link" aria-label={`Appeler Pimp My Place au ${AGENCY_PHONE_DISPLAY}`}>
          <Phone size={17} />
          <span>{AGENCY_PHONE_DISPLAY}</span>
        </a>
        <Link className="primary-button header-cta" to="/estimation" data-testid="header-estimate-link">
          <Sparkles size={17} />
          <span>Estimer mon bien</span>
        </Link>
        <button className="icon-button mobile-menu" data-testid="mobile-menu-button" onClick={() => setMenuOpen((open) => !open)} aria-label="Ouvrir le menu" aria-expanded={menuOpen}>
          <Menu size={20} />
        </button>
      </div>
      {menuOpen && <nav className="mobile-nav" data-testid="mobile-navigation-menu" aria-label="Navigation mobile">{navItems.map(([label, path]) => <NavLink key={label} to={path} onClick={closeMenu} data-testid={`mobile-navigation-${label.toLowerCase().replace("'", "")}-link`}>{label}</NavLink>)}<NavLink to="/alertes" onClick={closeMenu} data-testid="mobile-navigation-alerts-link">Alertes</NavLink><NavLink to="/parrainage" onClick={closeMenu} data-testid="mobile-navigation-referral-link">Parrainage 500 €</NavLink><a className="mobile-call-button" href={`tel:${AGENCY_PHONE}`} onClick={() => trackContactClick("phone", "mobile_menu")} data-testid="mobile-call-button"><Phone size={17} /> Appeler le {AGENCY_PHONE_DISPLAY}</a></nav>}
    </header>
  );
}